import { ArrowInCircleRightIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import type { WithDataTestid } from '@vlabs/uikit/types';
import { routes } from '@vlapps/point3/src/app/routes';
import { generatePath, Link } from 'react-router-dom';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import type { GoToPermissionTag } from './types';

type GoToPermissionTagIconButtonProps = GoToPermissionTag & WithDataTestid & IconButtonProps;

const displayName = 'GoToPermissionTagIconButton';
const testid = buildTestid('GoToPermissionTag');

function GoToPermissionTagIconButton({
  permissionTag,
  'data-testid': dataTestId = undefined,
  ...props
}: GoToPermissionTagIconButtonProps): JSX.Element {
  return (
    <IconButton
      as={Link}
      icon={<ArrowInCircleRightIcon />}
      kind="secondary"
      to={generatePath(routes.permissionTags.view, { permissionTag })}
      variant="flat"
      {...testid(permissionTag, dataTestId)}
      {...props}
    />
  );
}

GoToPermissionTagIconButton.displayName = displayName;

export { GoToPermissionTagIconButton };
